import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintwellbeing = () => {
  const title = "{BRAND.domainLabel} Hosts Roundtable with Mental Health Experts to Advance Online Safeguarding and User Wellbeing in social media networks"

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on June, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel}, a social media platform at the forefront of online
                safety and user wellbeing, continues to show its commitment to
                youth mental health following its beta launch during UK Mental
                Health Week earlier this year. As a UK tech startup,
                {BRAND.domainLabel} is focused on doing things the right way for young
                people.
              </p>

              <p>
                On 13th June, {BRAND.domainLabel} hosted a roundtable with mental
                health experts to discuss the platform's industry-leading Next
                of Kin feature – an alert system inspired by the NHS and aimed
                at saving lives online. Expert representatives from leading
                charities including Samaritans, Mental Health Innovations,
                PAPYRUS and campaigner Ellen Roome, who is also fundraising for
                the national charity PAPYRUS Prevention of Young Suicide,
                attended the roundtable and shared valuable insight.
              </p>

              <p>
                The Next of Kin feature on {BRAND.domainLabel} provides users with the
                reassurance that, in the event of a mental health emergency
                while using the platform, trusted individuals that they have
                chosen and consented to will be contacted for support. Inspired
                by the important work of suicide prevention charities,
                {BRAND.domainLabel} have created an informed definition of a mental
                health emergency when Next of Kin would be contacted.
              </p>

              <p>
                <strong>Co-founder Andrew Ahluwalia-Cook stated:</strong>
                "It is often easy to lose yourself online and forget that there
                are real people in the real world that care about you. We are
                trying to help the user realise and remember this with the Next
                of Kin feature through helping to guide our users in the
                direction of supportive services."
              </p>

              <p>
                Inspired by the campaigning work by Ellen Roome with regards to
                Jool's Law, the {BRAND.domainLabel} team are also exploring how the
                Next of Kin feature could be seen as providing consent for
                posthumous sharing of their data with trusted individuals.
              </p>

              <p>
                <strong>
                  Commenting on the roundtable, Co-Founder Harleen
                  Ahluwalia-Cook stated:
                </strong>
                "The roundtable brought together leading mental health voices to
                share their insights and help {BRAND.domainLabel} create a more mindful
                network where online safety and user wellbeing are embedded by
                design."
              </p>

              <p>
                This collaborative initiative is part of {BRAND.domainLabel}'s ongoing
                commitment to shape an alternative future for social networking.
                Designed from the ground up, {BRAND.domainLabel} is a platform where
                users are empowered to be their authentic selves in a safer,
                more supportive digital environment.
              </p>

              <p>
                As {BRAND.domainLabel} continues to grow its beta community, it remains
                dedicated to listening and evolving alongside its users,
                ensuring that safety and wellbeing are built into the very
                foundation of the platform.
              </p>

              <p>
                To see the platform and learn more about {BRAND.domainLabel}, please
                visit:{" "}
                <a href={BRAND.urls.marketing} target="_blank">
                  {BRAND.domainLabel}
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintwellbeing;
